export default __webpack_public_path__ + "static/media/open.0713dedf.svg";